module.exports = __webpack_public_path__ + "img/H4.42858505.png";